

// import React from 'react';
// import { Field } from 'formik';
// import { TextField, Chip, MenuItem, Select, FormControl, InputLabel, Box } from '@mui/material';
// import CancelIcon from '@mui/icons-material/Cancel';

// const ConsumerFormFields = ({ errors, touched, disabledFields = [], pumps = [], setFieldValue, values,update }) => {
//   const availablePumps = pumps.filter(pump => !values.imei_list?.includes(pump.imei));

//   const handleDeletePump = (imeiToDelete) => {
//     setFieldValue(
//       'imei_list',
//       values.imei_list.filter(imei => imei !== imeiToDelete)
//     );
//   };

//   return (
//     <div className="space-y-6">
//       <Field
//         as={TextField}
//         name="name"
//         label="Name"
//         variant="outlined"
//         fullWidth
//         margin="normal"
//         InputLabelProps={{
//           shrink: true,
//           sx: {
//             fontSize: '1.2rem',
//             '&.Mui-focused': {
//               fontSize: '1.2rem',
//               color: '#1976d2',
//             },
//           },
//         }}
//         InputProps={{
//           notched: true,
//           sx: {
//             '& .MuiOutlinedInput-notchedOutline legend': {
//               fontSize: '0.9rem',
//               width: 'max-content',
//             },
//           },
//         }}
//         error={touched.name && !!errors.name}
//         helperText={touched.name && errors.name}
//       />
//       <Field
//         as={TextField}
//         name="mobile_number"
//         label="Mobile Number (10 digits)"
//         variant="outlined"
//         fullWidth
//         margin="normal"
//         disabled={disabledFields.includes('mobile_number')}
//         InputLabelProps={{
//           shrink: true,
//           sx: {
//             fontSize: '1.2rem',
//             '&.Mui-focused': {
//               fontSize: '1.2rem',
//               color: '#1976d2',
//             },
//           },
//         }}
//         InputProps={{
//           notched: true,
//           sx: {
//             '& .MuiOutlinedInput-notchedOutline legend': {
//               fontSize: '0.9rem',
//               width: 'max-content',
//             },
//           },
//         }}
//         error={touched.mobile_number && !!errors.mobile_number}
//         helperText={touched.mobile_number && errors.mobile_number}
//       />
//       <Field
//         as={TextField}
//         name="farm_address"
//         label="Farm Address"
//         variant="outlined"
//         fullWidth
//         margin="normal"
//         InputLabelProps={{
//           shrink: true,
//           sx: {
//             fontSize: '1.2rem',
//             '&.Mui-focused': {
//               fontSize: '1.2rem',
//               color: '#1976d2',
//             },
//           },
//         }}
//         InputProps={{
//           notched: true,
//           sx: {
//             '& .MuiOutlinedInput-notchedOutline legend': {
//               fontSize: '0.9rem',
//               width: 'max-content',
//             },
//           },
//         }}
//         error={touched.farm_address && !!errors.farm_address}
//         helperText={touched.farm_address && errors.farm_address}
//       />
//       <Field
//         as={TextField}
//         name="service_number"
//         label="Service Number"
//         variant="outlined"
//         fullWidth
//         margin="normal"
//         InputLabelProps={{
//           shrink: true,
//           sx: {
//             fontSize: '1.2rem',
//             '&.Mui-focused': {
//               fontSize: '1.2rem',
//               color: '#1976d2',
//             },
//           },
//         }}
//         InputProps={{
//           notched: true,
//           sx: {
//             '& .MuiOutlinedInput-notchedOutline legend': {
//               fontSize: '0.9rem',
//               width: 'max-content',
//             },
//           },
//         }}
//         error={touched.service_number && !!errors.service_number}
//         helperText={touched.service_number && errors.service_number}
//       />
      
//      <FormControl fullWidth margin="normal" error={touched.imei_list && !!errors.imei_list}>
//   <InputLabel 
//     shrink 
//     sx={{
//       fontSize: '1.2rem',
//       '&.Mui-focused': {
//         fontSize: '1.2rem',
//         color: '#1976d2',
//       },
//     }}
//   >
//     Select Pump (IMEI)
//   </InputLabel>
//   {values.imei_list?.length > 0 ? (
//     <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 2 }}>
//       <Chip
//         label={
//           availablePumps.find(pump => pump.imei === values.imei_list[0])?.name
//             ? `${values.imei_list[0]} - ${availablePumps.find(pump => pump.imei === values.imei_list[0]).name}`
//             : values.imei_list[0]
//         }
//         onDelete={() => setFieldValue('imei_list', [])}
//         deleteIcon={<CancelIcon />}
//         sx={{ maxWidth: '80%' }}
//       />
//     </Box>
//   ) : (
//     <Select
//       multiple
//       value={values.imei_list || []}
//       onChange={(e) => setFieldValue('imei_list', [e.target.value[e.target.value.length - 1]])}
//       renderValue={(selected) => (
//         <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
//            {selected.map((imei) => (
//                 <Chip
//                   key={imei}
//                   label={imei}
//                   onDelete={() => handleDeletePump(imei)}
//                   deleteIcon={<CancelIcon onMouseDown={(event) => event.stopPropagation()} />}
//                 />
//               ))}
          
//         </Box>
//       )}
//       MenuProps={{
//         PaperProps: {
//           style: {
//             maxHeight: 300,
//           },
//         },
//       }}
//     >
//       <MenuItem value="" disabled>
//         Select a pump
//       </MenuItem>
//       {availablePumps.map((pump) => (
//         <MenuItem key={pump.imei} value={pump.imei}>
//           {pump.imei} - {pump.name || 'Unnamed Pump'}
//         </MenuItem>
//       ))}
//     </Select>
//   )}
//   {touched.imei_list && errors.imei_list && (
//     <div style={{ color: '#f44336', fontSize: '0.75rem', margin: '3px 14px 0' }}>
//       {errors.imei_list}
//     </div>
//   )}
// </FormControl>

//       <Field
//         as={TextField}
//         name="username"
//         label="Login Username (Mobile Number)"
//         value={values.mobile_number}
//         variant="outlined"
//         fullWidth
//         margin="normal"
//         disabled
//         InputLabelProps={{
//           shrink: true,
//           sx: {
//             fontSize: '1.2rem',
//             '&.Mui-focused': {
//               fontSize: '1.2rem',
//               color: '#1976d2',
//             },
//           },
//         }}
//         InputProps={{
//           notched: true,
//           sx: {
//             '& .MuiOutlinedInput-notchedOutline legend': {
//               fontSize: '0.9rem',
//               width: 'max-content',
//             },
//           },
//         }}
//         error={touched.username && !!errors.username}
//         helperText={touched.username && errors.username}
//       />

//       <Field
//         as={TextField}
//         name="password"
//         label={update?`Create New Password`:"Login Password"}
//         type="password"
//         variant="outlined"
//         fullWidth
//         margin="normal"
//         InputLabelProps={{
//           shrink: true,
//           sx: {
//             fontSize: '1.2rem',
//             '&.Mui-focused': {
//               fontSize: '1.2rem',
//               color: '#1976d2',
//             },
//           },
//         }}
//         InputProps={{
//           notched: true,
//           sx: {
//             '& .MuiOutlinedInput-notchedOutline legend': {
//               fontSize: '0.9rem',
//               width: 'max-content',
//             },
//           },
//         }}
//         error={touched.password && !!errors.password}
//         helperText={touched.password && errors.password}
//       />

      
//     </div>
//   );
// };

// export default ConsumerFormFields;









import React,{useState}from 'react';
import { Field ,useFormikContext} from 'formik';
import { TextField, Chip, MenuItem, Select, FormControl, InputLabel, Box, Grid, Typography,Button } from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';
import { Add as AddIcon, Delete as DeleteIcon } from '@mui/icons-material';


const ConsumerFormFields = ({ errors, touched, disabledFields = [], pumps = [], setFieldValue, values, update }) => {
  const availablePumps = pumps.filter(pump => !values.imei_list?.includes(pump.imei));

  // const handleDeletePump = (imeiToDelete) => {
  //   setFieldValue(
  //     'imei_list',
  //     values.imei_list.filter(imei => imei !== imeiToDelete)
  //   );
  // };
   const [currentPanelInput, setCurrentPanelInput] = useState('');
   //const { values } = useFormikContext();
  
    const handleAddPanelNumber = () => {
      if (currentPanelInput.trim() && !values.panel_number_list?.includes(currentPanelInput.trim())) {
        const updatedList = [...(values.panel_number_list || []), currentPanelInput.trim()];
        setFieldValue('panel_number_list', updatedList);
        setCurrentPanelInput('');
      }
    };
  
    const handleRemovePanelNumber = (indexToRemove) => {
      const updatedList = values.panel_number_list.filter((_, index) => index !== indexToRemove);
      setFieldValue('panel_number_list', updatedList);
    };
  
    const handlePanelInputKeyPress = (event) => {
      if (event.key === 'Enter') {
        event.preventDefault();
        handleAddPanelNumber();
      }
    };

  // Handle geolocation input changes
  const handleGeolocationChange = (index, value) => {
    const newGeolocation = values.geolocation ? [...values.geolocation] : [0, 0];
    newGeolocation[index] = value ? parseFloat(value) : '';
    setFieldValue('geolocation', newGeolocation);
  };

  return (
    <div className="space-y-6">
      <Field
        as={TextField}
        name="name"
        label="Name"
        variant="outlined"
        fullWidth
        margin="normal"
        InputLabelProps={{
          shrink: true,
          sx: {
            fontSize: '1.2rem',
            '&.Mui-focused': {
              fontSize: '1.2rem',
              color: '#1976d2',
            },
          },
        }}
        InputProps={{
          notched: true,
          sx: {
            '& .MuiOutlinedInput-notchedOutline legend': {
              fontSize: '0.9rem',
              width: 'max-content',
            },
          },
        }}
        error={touched.name && !!errors.name}
        helperText={touched.name && errors.name}
      />
      <Field
        as={TextField}
        name="mobile_number"
        label="Mobile Number (10 digits)"
        variant="outlined"
        fullWidth
        margin="normal"
        disabled={disabledFields.includes('mobile_number')}
        InputLabelProps={{
          shrink: true,
          sx: {
            fontSize: '1.2rem',
            '&.Mui-focused': {
              fontSize: '1.2rem',
              color: '#1976d2',
            },
          },
        }}
        InputProps={{
          notched: true,
          sx: {
            '& .MuiOutlinedInput-notchedOutline legend': {
              fontSize: '0.9rem',
              width: 'max-content',
            },
          },
        }}
        error={touched.mobile_number && !!errors.mobile_number}
        helperText={touched.mobile_number && errors.mobile_number}
      />
      <Field
        as={TextField}
        name="farm_address"
        label="Farm Address"
        variant="outlined"
        fullWidth
        margin="normal"
        InputLabelProps={{
          shrink: true,
          sx: {
            fontSize: '1.2rem',
            '&.Mui-focused': {
              fontSize: '1.2rem',
              color: '#1976d2',
            },
          },
        }}
        InputProps={{
          notched: true,
          sx: {
            '& .MuiOutlinedInput-notchedOutline legend': {
              fontSize: '0.9rem',
              width: 'max-content',
            },
          },
        }}
        error={touched.farm_address && !!errors.farm_address}
        helperText={touched.farm_address && errors.farm_address}
      />
      <Field
        as={TextField}
        name="service_number"
        label="Service Number"
        variant="outlined"
        fullWidth
        margin="normal"
        InputLabelProps={{
          shrink: true,
          sx: {
            fontSize: '1.2rem',
            '&.Mui-focused': {
              fontSize: '1.2rem',
              color: '#1976d2',
            },
          },
        }}
        InputProps={{
          notched: true,
          sx: {
            '& .MuiOutlinedInput-notchedOutline legend': {
              fontSize: '0.9rem',
              width: 'max-content',
            },
          },
        }}
        error={touched.service_number && !!errors.service_number}
        helperText={touched.service_number && errors.service_number}
      />
      
      <FormControl fullWidth margin="normal" error={touched.imei_list && !!errors.imei_list}>
        <InputLabel 
          shrink 
          sx={{
            fontSize: '1.2rem',
            '&.Mui-focused': {
              fontSize: '1.2rem',
              color: '#1976d2',
            },
            marginTop:'-10px'
          }}
        >
          Select Pump (IMEI)
        </InputLabel>
        {values.imei_list?.length > 0 ? (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 2 }}>
            <Chip
              label={
                pumps.find(pump => pump.imei === values.imei_list[0])?.name
                  ? `${values.imei_list[0]} - ${pumps.find(pump => pump.imei === values.imei_list[0]).name}`
                  : values.imei_list[0]
              }
              onDelete={() => setFieldValue('imei_list', [])}
              deleteIcon={<CancelIcon />}
              sx={{ maxWidth: '80%' }}
            />
          </Box>
        ) : (
          <Select
            multiple
            value={values.imei_list || []}
            onChange={(e) => setFieldValue('imei_list', [e.target.value[e.target.value.length - 1]])}
            renderValue={(selected) => (
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                {selected.map((imei) => (
                  <Chip
                    key={imei}
                    label={imei}
                    onDelete={() => setFieldValue('imei_list', [])}
                    deleteIcon={<CancelIcon onMouseDown={(event) => event.stopPropagation()} />}
                  />
                ))}
              </Box>
            )}
            MenuProps={{
              PaperProps: {
                style: {
                  maxHeight: 300,
                },
              },
            }}
          >
            <MenuItem value="" disabled>
              Select a pump
            </MenuItem>
            {availablePumps.map((pump) => (
              <MenuItem key={pump.imei} value={pump.imei}>
                {pump.imei} - {pump.name || 'Unnamed Pump'}
              </MenuItem>
            ))}
          </Select>
        )}
        {touched.imei_list && errors.imei_list && (
          <div style={{ color: '#f44336', fontSize: '0.75rem', margin: '3px 14px 0' }}>
            {errors.imei_list}
          </div>
        )}
      </FormControl>

      {/* Geolocation Field */}
      <FormControl fullWidth margin="normal" error={touched.geolocation && !!errors.geolocation}>
        <InputLabel 
          shrink 
          sx={{
            fontSize: '1.2rem',
            '&.Mui-focused': {
              fontSize: '1.2rem',
              color: '#1976d2',
            },
          }}
        >
          Geolocation
        </InputLabel>
        <Box sx={{ mt: 2 }}>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Field
                as={TextField}
                name="geolocation[0]"
                label="Latitude"
                type="number"
                variant="outlined"
                fullWidth
                InputLabelProps={{
                  shrink: true,
                  sx: {
                    fontSize: '1rem',
                    '&.Mui-focused': {
                      fontSize: '1rem',
                      color: '#1976d2',
                    },
                  },
                }}
                InputProps={{
                  notched: true,
                  sx: {
                    '& .MuiOutlinedInput-notchedOutline legend': {
                      fontSize: '0.85rem',
                      width: 'max-content',
                    },
                  },
                  inputProps: {
                    step: 'any',
                    min: -90,
                    max: 90,
                  },
                }}
                value={values.geolocation?.[0] || ''}
                onChange={(e) => handleGeolocationChange(0, e.target.value)}
                error={touched.geolocation && !!errors.geolocation?.[0]}
                helperText={touched.geolocation && errors.geolocation?.[0]}
              />
            </Grid>
            <Grid item xs={6}>
              <Field
                as={TextField}
                name="geolocation[1]"
                label="Longitude"
                type="number"
                variant="outlined"
                fullWidth
                InputLabelProps={{
                  shrink: true,
                  sx: {
                    fontSize: '1rem',
                    '&.Mui-focused': {
                      fontSize: '1rem',
                      color: '#1976d2',
                    },
                  },
                }}
                InputProps={{
                  notched: true,
                  sx: {
                    '& .MuiOutlinedInput-notchedOutline legend': {
                      fontSize: '0.85rem',
                      width: 'max-content',
                    },
                  },
                  inputProps: {
                    step: 'any',
                    min: -180,
                    max: 180,
                  },
                }}
                value={values.geolocation?.[1] || ''}
                onChange={(e) => handleGeolocationChange(1, e.target.value)}
                error={touched.geolocation && !!errors.geolocation?.[1]}
                helperText={touched.geolocation && errors.geolocation?.[1]}
              />
            </Grid>
          </Grid>
        </Box>
        {touched.geolocation && errors.geolocation && typeof errors.geolocation === 'string' && (
          <div style={{ color: '#f44336', fontSize: '0.75rem', margin: '3px 14px 0' }}>
            {errors.geolocation}
          </div>
        )}
      </FormControl>
      <FormControl fullWidth margin="normal" error={touched.panel_number_list && !!errors.panel_number_list}>
              <InputLabel 
                shrink 
                sx={{
                  fontSize: '1.2rem',
                  '&.Mui-focused': {
                    fontSize: '1.2rem',
                    color: '#1976d2',
                  },
                  marginTop: '-10px'
                }}
              >
                Panel Number
              </InputLabel>
              
              {/* Input field for adding new panel numbers */}
              <Box sx={{ display: 'flex', gap: 1, mt: 2, alignItems: 'center' }}>
                <TextField
                  value={currentPanelInput}
                  onChange={(e) => setCurrentPanelInput(e.target.value)}
                  onKeyPress={handlePanelInputKeyPress}
                  placeholder="Enter panel number"
                  variant="outlined"
                  size="small"
                  sx={{ flexGrow: 1 }}
                  inputProps={{
                    style: { fontSize: '1rem' }
                  }}
                />
                <Button
                  variant="contained"
                  onClick={handleAddPanelNumber}
                  disabled={!currentPanelInput.trim() || values.panel_number_list?.includes(currentPanelInput.trim())}
                  startIcon={<AddIcon />}
                  sx={{
                    minWidth: 'auto',
                    px: 2,
                    backgroundColor: '#1976d2',
                    '&:hover': {
                      backgroundColor: '#1565c0',
                    }
                  }}
                >
                  Add
                </Button>
              </Box>
      
              {/* Display added panel numbers */}
              {values.panel_number_list && values.panel_number_list.length > 0 && (
                <Box sx={{ mt: 2 }}>
                  <Typography variant="body2" color="textSecondary" sx={{ mb: 1 }}>
                    Added Panel Numbers ({values.panel_number_list.length}):
                  </Typography>
                  <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                    {values.panel_number_list.map((panelNumber, index) => (
                      <Chip
                        key={`${panelNumber}-${index}`}
                        label={panelNumber}
                        onDelete={() => handleRemovePanelNumber(index)}
                        deleteIcon={<DeleteIcon />}
                        variant="outlined"
                        sx={{
                          backgroundColor: '#f5f5f5',
                          '&:hover': {
                            backgroundColor: '#e0e0e0',
                          }
                        }}
                      />
                    ))}
                  </Box>
                  <Button
                    variant="text"
                    color="error"
                    size="small"
                    onClick={() => setFieldValue('panel_number_list', [])}
                    sx={{ mt: 1, textTransform: 'none' }}
                  >
                    Clear All ({values.panel_number_list.length})
                  </Button>
                </Box>
              )}
      
              {touched.panel_number_list && errors.panel_number_list && (
                <Typography variant="caption" color="error" sx={{ mt: 1, fontSize: '0.75rem' }}>
                  {errors.panel_number_list}
                </Typography>
              )}
            </FormControl>
      

      <Field
        as={TextField}
        name="username"
        label="Login Username (Mobile Number)"
        value={values.mobile_number}
        variant="outlined"
        fullWidth
        margin="normal"
        disabled
        InputLabelProps={{
          shrink: true,
          sx: {
            fontSize: '1.2rem',
            '&.Mui-focused': {
              fontSize: '1.2rem',
              color: '#1976d2',
            },
          },
        }}
        InputProps={{
          notched: true,
          sx: {
            '& .MuiOutlinedInput-notchedOutline legend': {
              fontSize: '0.9rem',
              width: 'max-content',
            },
          },
        }}
        error={touched.username && !!errors.username}
        helperText={touched.username && errors.username}
      />

      <Field
        as={TextField}
        name="password"
        label={update ? `Create New Password` : "Login Password"}
        type="password"
        variant="outlined"
        fullWidth
        margin="normal"
        InputLabelProps={{
          shrink: true,
          sx: {
            fontSize: '1.2rem',
            '&.Mui-focused': {
              fontSize: '1.2rem',
              color: '#1976d2',
            },
          },
        }}
        InputProps={{
          notched: true,
          sx: {
            '& .MuiOutlinedInput-notchedOutline legend': {
              fontSize: '0.9rem',
              width: 'max-content',
            },
          },
        }}
        error={touched.password && !!errors.password}
        helperText={touched.password && errors.password}
      />
    </div>
  );
};

export default ConsumerFormFields;